class TesterPackBuilder extends HTMLElement {
  connectedCallback() {
    // Read attributes HERE, not in the constructor — they aren't
    // attached yet when the parser builds the element.
    this.variantId = this.dataset.variantId;
    this.max = parseInt(this.dataset.max || '4', 10);
    this.cartUrl = this.dataset.cartUrl || '/cart';

    this.cards = Array.from(this.querySelectorAll('.tpb-card'));
    this.countEl = this.querySelector('.tpb-count-current');
    this.submitBtn = this.querySelector('.tpb-submit');
    this.errorEl = this.querySelector('.tpb-error');
    this.bar = this.querySelector('.tpb-bar');

    if (!this.variantId) {
      console.warn('[tester-pack-builder] missing data-variant-id');
    }

    this.submitLabel = this.submitBtn.textContent;
    this.submitBtn.type = 'button';

    this.cards.forEach((card) => {
      const checkbox = card.querySelector('.tpb-checkbox');

      card.addEventListener('click', (event) => {
        // Swallow the duplicate click the browser forwards from a
        // <label> to its input.
        if (event.target === checkbox) {
          event.preventDefault();
          return;
        }
        event.preventDefault();

        if (card.classList.contains('is-disabled') && !card.classList.contains('is-selected')) {
          return;
        }

        checkbox.checked = !checkbox.checked;
        card.classList.toggle('is-selected', checkbox.checked);
        this.updateState();
      });
    });

    this.submitBtn.addEventListener('click', () => this.addToCart());
    this.updateState();
  }

  getSelectedCards() {
    return this.cards.filter((card) => card.classList.contains('is-selected'));
  }

  updateState({ keepError = false } = {}) {
    const selected = this.getSelectedCards();
    this.countEl.textContent = selected.length;

    const atMax = selected.length >= this.max;
    this.cards.forEach((card) => {
      if (!card.classList.contains('is-selected')) {
        card.classList.toggle('is-disabled', atMax);
      }
    });

    this.submitBtn.disabled = selected.length !== this.max || !this.variantId;
    if (!keepError) this.errorEl.textContent = '';

    if (this.bar) {
      this.bar.hidden = selected.length === 0;
    }
  }

  addToCart() {
    const selected = this.getSelectedCards();
    if (selected.length !== this.max || !this.variantId) return;

    const properties = {};
    selected.forEach((card, index) => {
      properties[`Scent ${index + 1}`] = card.querySelector('.tpb-checkbox').value;
    });

    this.submitBtn.disabled = true;
    this.submitBtn.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(this.variantId), quantity: 1, properties }],
      }),
    })
      .then((response) =>
        response.json().then((data) => {
          if (!response.ok) {
            throw new Error(data.description || data.message || 'Could not add tester pack to cart.');
          }
          return data;
        })
      )
      .then(() => {
        window.location.href = this.cartUrl;
      })
      .catch((error) => {
        this.submitBtn.textContent = this.submitLabel;
        this.updateState({ keepError: true });
        this.errorEl.textContent = error.message;
      });
  }
}

customElements.define('tester-pack-builder', TesterPackBuilder);